module.exports = __webpack_public_path__ + "1_0_57/img/taskpal.4cca17ae.svg";